var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-3 h-6 rounded-full text-xs font-semibold flex items-center",class:`bg-${_vm.color}-100 text-${_vm.color}-700`},[_c('span',{staticClass:"w-2 h-2 rounded-full mr-1",class:`bg-${_vm.color}-400`}),_c('span',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }